import { render, staticRenderFns } from "./AuthModalsWrapper.vue?vue&type=template&id=82abb588&"
import script from "./AuthModalsWrapper.vue?vue&type=script&lang=js&"
export * from "./AuthModalsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports